import React from 'react';

// Components
import Toolbar from '../../components/UI/Toolbar/Toolbar';
import CreatePreconfiguration from '../../components/CreatePreconfigurationPage/CreatePreconfiguration.tsx/CreatePreconfiguration';

// Interfaces
import { Preconfiguration } from '../../interfaces/Preconfigurations';

// Language
import { useTranslation } from 'react-i18next';

// Other
import { useLocation } from 'react-router-dom';

const CreatePreconfigurationPage: React.FC = () => {

    const { t } = useTranslation();

    const location = useLocation();

    const preconfig: Preconfiguration | undefined = location.state?.preconfiguration ?? undefined;

    return (
        <>
            <Toolbar
                text={t('preconfigurations')}
                link='/home/administration/preconfiguration'
            />
            <CreatePreconfiguration defaultPreconfig={preconfig} />
        </>
    );
};

export default CreatePreconfigurationPage;